<mat-toolbar color="primary">
  <span id="registrer-saksdokument-dialog-tittel">
    {{ 'Registrer nytt saksdokument'|translate }}
  </span>
  <button mat-icon-button aria-label="Lukk dialog" (click)="avbryt()">
    <mat-icon fontSet="ion-ios-close-empty" class="mat-icon--ionic-ikon"/>
  </button>
</mat-toolbar>

<div (draOgSlippFil)="filerValgtForOpplasting($event)"
     (draOgSlippAktivert)="draOgSlippAktivert.set($event)"
     [meldingVedAktivert]="draOgSlippIndikatorFragment"
     [meldingVedIkkeStoettet]="draOgSlippIkkeStoettetIndikatorFragment"></div>
<ng-template #draOgSlippIndikatorFragment>
  <dra-og-slipp-fil-aktivert-melding>{{ 'Slipp filene for å registrere de som saksdokumenter under sak {tittel}'|translate: {tittel: sak.tittel} }}</dra-og-slipp-fil-aktivert-melding>
</ng-template>
<!--ikke i bruk siden draOgSlippStøttet ikke er angitt (std er true), men meldingVedIkkeStoettet er påkrevet-->
<ng-template #draOgSlippIkkeStoettetIndikatorFragment></ng-template>


@if (!viserProtokollvelger() && !viserSpoerreundersoekelsevelger()) {
  <mat-dialog-content>
    <div class="last-opp">
      <span>
        <button mat-stroked-button color="primary" (click)="filInput.click()">
          <mat-icon>cloud_upload</mat-icon>
          {{ 'Velg fil fra din maskin'|translate }}
        </button>
        <input type="file" multiple [accept]="tillatteFiltyper()" (change)="registrerSaksdokument($event)" hidden data-testid="nytt-saksdokument-fil-felt" #filInput>
      </span>
      <span class="eller">{{ 'eller en av'|translate }}</span>
    </div>

    <mat-tab-group [selectedIndex]="aktivArkfane()" (selectedIndexChange)="aktivArkfane.set($event)">
      <mat-tab label="{{'Genererte dokumenter'|translate}}">
        <div class="genererte-dokumenter">
          @for (dokument of genererteDokumenter; track $index) {
            <dokument (click)="dokument.vedKlikk()" role="button" [attr.aria-label]="dokument.tittel">
              <ng-container bakgrunn [tittel]="dokument.tittel">
                <dokument-format-ikon [mimeinfo]="dokument.mimeinfo" utenDokumentramme="true" stoerrelse="50"/>
              </ng-container>
              <div handling matTooltip="{{'Registrer {rapport} som saksdokument'|translate:{rapport: dokument.tittel} }}" [attr.data-testid]="dokument.testid">
                <mat-icon>check_circle</mat-icon>
              </div>
              <div filnavn>{{ dokument.filnavn }}</div>
            </dokument>
          }
        </div>
      </mat-tab>

      <mat-tab label="{{'Biblioteksdokument'|translate}}">
        <div class="biblioteksdokumenter">
          <h3 id="registrer-saksdokument-dialog-velg-arkivnode-tittel">{{ 'Velg bibliotekdokumentet du vil legge til i saken'|translate }}</h3>
          @if (aktivArkfane() === 1) {
            <arkiv-velg-node [gruppeId]="sak.eiendeGruppeId" [kanVelges]="kunArkivdokumenter" [kontroll]="valgtArkivdokumentKontroll" ariaLabelledBy="registrer-saksdokument-dialog-velg-arkivnode-tittel"/>
            @if (valgtArkivdokumentKontroll.value != null) {
              <div class="valg-dokument">
                <div class="tittel">{{ 'Du har valgt følgende bibliotekdokument:'|translate }}</div>
                <dokument-kortvisning [dokumentversjon]="valgtArkivdokumentKontroll.value.dokument" visSkjermingDeaktivert="true" signeringDeaktivert="true" visNymerkingDeaktivert="true" data-testid="valgt-arkivdokument"/>
                <button mat-raised-button color="primary" (click)="registrerArkivdokument()" [disabled]="arbeider()" #registrerArkivdokumentKnapp>
                  {{ 'Registrer som saksdokument'|translate }}
                </button>
              </div>
            }
          }
        </div>
      </mat-tab>

      <mat-tab label="{{'Skytjenester'|translate}}">
        <div class="skytjenester">
          <googledrive-filvelger [sak]="sak" (vedAktivert)="skydokumentFilvelgerAktivert()"/>
          <onedrive-filvelger [sak]="sak" (vedAktivert)="skydokumentFilvelgerAktivert()"/>
        </div>
      </mat-tab>
    </mat-tab-group>
    <tips>{{ 'Du kan også dra-og-slippe filer over saken for å laste opp saksdokumenter'|translate }}</tips>
  </mat-dialog-content>

} @else if (viserProtokollvelger()) {
  <!-- gui for å velge protokoll -->
  <mat-dialog-content>
  <div class="velg-protokoller">
    <h3 id="registrer-saksdokument-dialog-velg-moeteprotokoll-tittel">{{ 'Velg hvilket møter du vil inkludere protokoll fra'|translate }}</h3>
    <mat-slide-toggle [formControl]="inkluderProtokollerTilBehandling">{{ 'Inkluder møter der protokoll allerede er til behandling i annen sak'|translate }}</mat-slide-toggle>
    @if (arbeider()) {
      <laster-data>{{ 'Laster...'|translate }}</laster-data>
    }
    @if (tilgjengeligeProtokoller().length == 0 && !arbeider()) {
      <inline-melding>{{ 'Det finnes ingen tidligere møter. Kun protokoller for møter avholdt før dette møtet kan legges til saken.'|translate }}</inline-melding>
    }
    <velg-moeteprotokoll [kontroller]="valgtProtokollKontroll" [tilgjengeligeMoeter]="tilgjengeligeProtokoller()" tillatVelgFlere="true" ariaLabelledBy="registrer-saksdokument-dialog-velg-moeteprotokoll-tittel"/>
  </div>
  </mat-dialog-content>
  <mat-dialog-actions align="center">
    <button mat-raised-button color="primary" (click)="registrerProtokolldokumentForMoete()" [disabled]="valgtProtokollKontroll.invalid || arbeider()">
      {{ 'Registrer protokolldokumenter for {antall} møter'|translate: {antall: valgtProtokollKontroll.value.length} }}
    </button>
    <button mat-button (click)="avbrytRegistrerProtokolldokumentForMoete()">{{ 'Tilbake'|translate }}</button>
  </mat-dialog-actions>

} @else if (viserSpoerreundersoekelsevelger()) {
  <!-- gui for å velge protokoll -->
  <mat-dialog-content>
    <div class="velg-spørreundersøkelse">
      <h3>{{ 'Velg hvilken spørreundersøkelse du vil inkludere resultat-rapport for'|translate }}</h3>
      <mat-slide-toggle [formControl]="inkluderSpoerreundersoekelserTilBehandling">{{ 'Inkluder spørreundersøkelser som allerede er til behandling i annen sak'|translate }}</mat-slide-toggle>
      @if (arbeider()) {
        <laster-data>{{ 'Laster...'|translate }}</laster-data>
      }
      @if (tilgjengeligeSpoerreundersoekelser().length == 0 && !arbeider()) {
        <tips>
          <div>{{ 'Det er ikke gjennomført noen spørreundersøkelser i denne gruppen.'|translate }}</div>
          <div>
            {{ 'Gjennomfør din første styreevaluering ved å gå til'|translate }}
            <a (click)="navigerTilStyreevaluering()">{{ 'evalueringer'|translate }}</a>
          </div>
        </tips>
      }
    </div>
    <velg-spoerreundersoekelse [kontroller]="valgtSpoerreundersoekelseKontroll" [tilgjengeligeUndersoekelser]="tilgjengeligeSpoerreundersoekelser()" tillatVelgFlere="true"/>
  </mat-dialog-content>
  <mat-dialog-actions align="center">
    <button mat-raised-button color="primary" (click)="registrerSpoerreundersoekelseRapport()" [disabled]="valgtSpoerreundersoekelseKontroll.invalid || arbeider()">
      {{ 'Registrer rapport som saksdokument'|translate }}
    </button>
    <button mat-button (click)="avbrytVelgSpoerreundersoekelse()">{{ 'Tilbake'|translate }}</button>
  </mat-dialog-actions>
}
